"use strict";

/**
 * Animated Image Block JavaScript
 * Moves image left/right based on scroll, only when block is in view
 */

(function ($) {
  'use strict';

  /**
   * Initialize animated image blocks
   */
  function initAnimatedImageBlocks() {
    var blocks = document.querySelectorAll('.animated-image-block');
    if (blocks.length === 0) return;
    blocks.forEach(function (block) {
      var animatedImage = block.querySelector('.animated-image-block__animated-image');
      if (!animatedImage) return;
      var animationSpeed = parseFloat(block.dataset.animationSpeed) || 0.5;
      var lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;
      var currentPosition = 0;
      var isInView = false;
      var scrollListener = null;

      // Create Intersection Observer to detect when block is in view
      var observerOptions = {
        root: null,
        rootMargin: '0px',
        threshold: 0.1 // Trigger when 10% visible
      };
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          isInView = entry.isIntersecting;
          if (isInView && !scrollListener) {
            // Block entered view - start scroll tracking
            lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;
            attachScrollListener();
          } else if (!isInView && scrollListener) {
            // Block left view - stop scroll tracking
            detachScrollListener();
          }
        });
      }, observerOptions);
      function updatePosition() {
        if (!isInView) return;
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        var scrollDelta = scrollTop - lastScrollTop;

        // Move left when scrolling down, right when scrolling up
        currentPosition -= scrollDelta * animationSpeed;

        // Apply transform
        animatedImage.style.transform = "translateX(".concat(currentPosition, "px)");
        lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
      }

      // Use requestAnimationFrame for smooth animation
      var ticking = false;
      function onScroll() {
        if (!ticking) {
          window.requestAnimationFrame(function () {
            updatePosition();
            ticking = false;
          });
          ticking = true;
        }
      }
      function attachScrollListener() {
        scrollListener = onScroll;
        window.addEventListener('scroll', scrollListener, {
          passive: true
        });
      }
      function detachScrollListener() {
        if (scrollListener) {
          window.removeEventListener('scroll', scrollListener);
          scrollListener = null;
        }
      }

      // Start observing the block
      observer.observe(block);
    });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAnimatedImageBlocks);
  } else {
    initAnimatedImageBlocks();
  }
})(jQuery);